const gameData = [
  {
    'name': 'Chrome恐龙',
    'id': '001',
    'type': 'both', 'desc': 'Chrome浏览器彩蛋',
    'more': '如果你曾经用过谷歌浏览器，那你一定对下面这个萌萌哒的小恐龙不陌生。谷歌最著名的彩蛋，就是当浏览器断网之后，页面上会出现一只像素恐龙，提示你未能连接到互联网。',
    'url': 'https://game.chenmo1212.cn/content/001/index.html',
    'cover': 'https://game.chenmo1212.cn/content/001/cover.png'
  }, {
    'name': '叠方块',
    'id': '002',
    'type': 'phone', 'desc': '一款轻松愉快又刺激的小游戏',
    'more': '点击方块使之叠在之前的方块上，看你能叠多高吧~',
    'url': 'https://game.chenmo1212.cn/content/002/index.html',
    'cover': 'https://game.chenmo1212.cn/content/002/cover.png'
  }, {
    'name': '英文打字测试',
    'id': '003',
    'type': 'pc', 'desc': '一款简单的PC端测试英文打字速度游戏',
    'more': '按照字母表的顺序打字，看你的速度能有多快',
    'url': 'https://game.chenmo1212.cn/content/003/index.html',
    'cover': 'https://game.chenmo1212.cn/content/003/cover.png'
  }, {
    'name': '俄罗斯方块小游戏',
    'id': '004',
    'type': 'pc', 'desc': '是一款经典的小游戏',
    'more': '俄罗斯方块，不多介绍，玩就完事了',
    'url': 'https://game.chenmo1212.cn/content/004/index.html',
    'cover': 'https://game.chenmo1212.cn/content/004/cover.png'
  }, {
    'name': '闭环小游戏',
    'id': '005',
    'type': 'both', 'desc': '闭环小游戏',
    'more': '闭环小游戏',
    'url': 'https://game.chenmo1212.cn/content/005/index.html',
    'cover': 'https://game.chenmo1212.cn/content/005/cover.png'
  }, {
    'name': '一个都不能死',
    'id': '006',
    'type': 'both', 'desc': '一个都不能死',
    'more': '一个都不能死',
    'url': 'https://game.chenmo1212.cn/content/006/index.html',
    'cover': 'https://game.chenmo1212.cn/content/006/cover.png'
  }, {
    'name': '冒险闯关小游戏',
    'id': '007',
    'type': 'pc', 'desc': '冒险闯关小游戏',
    'more': '简易的冒险闯关小游戏',
    'url': 'https://game.chenmo1212.cn/content/007/index.html',
    'cover': 'https://game.chenmo1212.cn/content/007/cover.png'
  }, {
    'name': '改色球',
    'id': '008',
    'type': 'both', 'desc': '改色球',
    'more': '改色球',
    'url': 'https://game.chenmo1212.cn/content/008/index.html',
    'cover': 'https://game.chenmo1212.cn/content/008/cover.png'
  }, {
    'name': 'fly bird',
    'id': '009',
    'type': 'both', 'desc': 'fly bird',
    'more': 'fly bird',
    'url': 'https://game.chenmo1212.cn/content/009/index.html',
    'cover': 'https://game.chenmo1212.cn/content/009/cover.png'
  }, {
    'name': '无尽河流',
    'id': '010',
    'type': 'both', 'desc': '无尽河流',
    'more': '无尽河流',
    'url': 'https://game.chenmo1212.cn/content/010/index.html',
    'cover': 'https://game.chenmo1212.cn/content/010/cover.png'
  }, {
    'name': '简易闯关游戏',
    'id': '011',
    'type': 'pc', 'desc': '简易闯关游戏',
    'more': '简易闯关游戏',
    'url': 'https://game.chenmo1212.cn/content/011/index.html',
    'cover': 'https://game.chenmo1212.cn/content/011/cover.png'
  }, {
    'name': '吃豆人',
    'id': '012',
    'type': 'pc', 'desc': '经典吃豆人小游戏',
    'more': '经典吃豆人小游戏，仅支持pc端',
    'url': 'https://game.chenmo1212.cn/content/012/index.html',
    'cover': 'https://game.chenmo1212.cn/content/012/cover.png'
  }, {
    'name': '2048小游戏',
    'id': '013',
    'type': 'both', 'desc': '带有音效的2048小游戏',
    'more': '2048小游戏，github上可以找到源码，站主在原有基础上加上了音效。',
    'url': 'https://game.chenmo1212.cn/content/013/index.html',
    'cover': 'https://game.chenmo1212.cn/content/013/cover.png'
  }, {
    'name': '维京战争手机游戏',
    'id': '014',
    'type': 'both', 'desc': '维京战争手机游戏',
    'more': '维京战争手机游戏',
    'url': 'https://game.chenmo1212.cn/content/014/index.html',
    'cover': 'https://game.chenmo1212.cn/content/014/cover.png'
  }, {
    'name': '颜色消消小游戏',
    'id': '015',
    'type': 'both', 'desc': '颜色消消小游戏',
    'more': '颜色消消小游戏',
    'url': 'https://game.chenmo1212.cn/content/015/index.html',
    'cover': 'https://game.chenmo1212.cn/content/015/cover.png'
  }, {
    'name': '踩雷小游戏',
    'id': '016',
    'type': 'both', 'desc': '踩雷小游戏',
    'more': '源码在github中可以找到，这是一个很优秀的踩雷游戏，具有多种模式。',
    'url': 'https://game.chenmo1212.cn/content/016/index.html',
    'cover': 'https://game.chenmo1212.cn/content/016/cover.png'
  }, {
    'name': '切方块小游戏',
    'id': '017',
    'type': 'both', 'desc': '切方块小游戏，仿切西瓜小游戏',
    'more': '切方块小游戏，不切西瓜了，来切个方块玩玩',
    'url': 'https://game.chenmo1212.cn/content/017/index.html',
    'cover': 'https://game.chenmo1212.cn/content/017/cover.png'
  }, {
    'name': '找色差小游戏',
    'id': '018',
    'type': 'both', 'desc': '十分考验眼力和速度的小游戏',
    'more': '找色差小游戏，十分考验眼力和速度的小游戏，带有有趣的音效。',
    'url': 'https://game.chenmo1212.cn/content/018/index.html',
    'cover': 'https://game.chenmo1212.cn/content/018/cover.png'
  }, {
    'name': '特工卡尔施',
    'id': '019',
    'type': 'pc', 'desc': '一款比较好玩的冒险类游戏',
    'more': '特工卡尔施，一款比较好玩的冒险类游戏',
    'url': 'https://game.chenmo1212.cn/content/019/index.html',
    'cover': 'https://game.chenmo1212.cn/content/019/cover.png'
  }, {
    'name': '迷失岛',
    'id': '020',
    'type': 'pc', 'desc': '迷失岛，一款简单易上手的闯关游戏',
    'more': '迷失岛，一款简单易上手的闯关游戏',
    'url': 'https://game.chenmo1212.cn/content/020/index.html',
    'cover': 'https://game.chenmo1212.cn/content/020/cover.png'
  }, {
    'name': '赛车俱乐部',
    'id': '021',
    'type': 'both', 'desc': '赛车俱乐部，十分简易的赛车游戏',
    'more': '赛车俱乐部，十分简易的赛车游戏',
    'url': 'https://game.chenmo1212.cn/content/021/index.html',
    'cover': 'https://game.chenmo1212.cn/content/021/cover.png'
  }, {
    'name': '爬楼层',
    'id': '022',
    'type': 'both', 'desc': '爬楼层',
    'more': '简易的爬楼层小游戏',
    'url': 'https://game.chenmo1212.cn/content/022/index.html',
    'cover': 'https://game.chenmo1212.cn/content/022/cover.png'
  }, {
    'name': '萌萌水贼',
    'id': '023',
    'type': 'both', 'desc': '萌萌水贼，超萌又休闲的小游戏',
    'more': '萌萌水贼，超萌又休闲的小游戏',
    'url': 'https://game.chenmo1212.cn/content/023/index.html',
    'cover': 'https://game.chenmo1212.cn/content/023/cover.png'
  }, {
    'name': 'X赛车',
    'id': '024',
    'type': 'both', 'desc': 'X赛车，另一款比较好玩的小游戏',
    'more': 'X赛车，另一款比较好玩的小游戏',
    'url': 'https://game.chenmo1212.cn/content/024/index.html',
    'cover': 'https://game.chenmo1212.cn/content/024/cover.png'
  }, {
    'name': 'Flappy 2048',
    'id': '025',
    'type': 'both', 'desc': '结合了fly bird和2048的休闲游戏',
    'more': '结合了fly bird和2048的休闲游戏，非常值得一玩。',
    'url': 'https://game.chenmo1212.cn/content/025/index.html',
    'cover': 'https://game.chenmo1212.cn/content/025/cover.png'
  }, {
    'name': '驴子跳跳小游戏',
    'id': '026',
    'type': 'both', 'desc': '驴子跳跳小游戏',
    'more': '驴子跳跳小游戏，看你能上多少层',
    'url': 'https://game.chenmo1212.cn/content/026/index.html',
    'cover': 'https://game.chenmo1212.cn/content/026/cover.png'
  }, {
    'name': '最强眼力',
    'id': '027',
    'type': 'both', 'desc': '最强眼力，一个考验眼力的小游戏',
    'more': '一个考验眼力的小游戏，你能闯到第十关吗？',
    'url': 'https://game.chenmo1212.cn/content/027/index.html',
    'cover': 'https://game.chenmo1212.cn/content/027/cover.png'
  }, {
    'name': '3D兔子跑酷',
    'id': '028',
    'type': 'pc', 'desc': '3D兔子跑酷',
    'more': '3D兔子跑酷',
    'url': 'https://game.chenmo1212.cn/content/028/index.html',
    'cover': 'https://game.chenmo1212.cn/content/028/cover.png'
  }, {
    'name': '泡泡龙',
    'id': '029',
    'type': 'both', 'desc': '回忆童年的泡泡龙',
    'more': '经典游戏泡泡龙，回忆童年',
    'url': 'https://game.chenmo1212.cn/content/029/index.html',
    'cover': 'https://game.chenmo1212.cn/content/029/cover.png'
  }, {
    'name': '翻牌记忆小游戏',
    'id': '030',
    'type': 'both', 'desc': '翻牌记忆小游戏',
    'more': '翻牌记忆小游戏',
    'url': 'https://game.chenmo1212.cn/content/030/index.html',
    'cover': 'https://game.chenmo1212.cn/content/030/cover.png'
  }, {
    'name': '永不放弃',
    'id': '032',
    'type': 'pc', 'desc': '永不放弃',
    'more': '永不放弃',
    'url': 'https://game.chenmo1212.cn/content/032/index.html',
    'cover': 'https://game.chenmo1212.cn/content/032/cover.png'
  }, {
    'name': '火柴人绳索挑战',
    'id': '035',
    'type': 'pc', 'desc': '火柴人绳索挑战小游戏',
    'more': '火柴人绳索挑战小游戏，刺激又好玩的小游戏',
    'url': 'https://game.chenmo1212.cn/content/035/index.html',
    'cover': 'https://game.chenmo1212.cn/content/035/cover.png'
  }, {
    'name': '海盗僵尸杀杀杀',
    'id': '036',
    'type': 'both', 'desc': '海盗僵尸杀杀杀小游戏',
    'more': '海盗僵尸杀杀杀，一款冒险闯关的小游戏',
    'url': 'https://game.chenmo1212.cn/content/036/index.html',
    'cover': 'https://game.chenmo1212.cn/content/036/cover.png'
  }, {
    'name': '僵尸鸭猎手',
    'id': '037',
    'type': 'both', 'desc': '僵尸鸭猎手小游戏',
    'more': '僵尸鸭猎手，一款考验手速的小游戏',
    'url': 'https://game.chenmo1212.cn/content/037/index.html',
    'cover': 'https://game.chenmo1212.cn/content/037/cover.png'
  }, {
    'name': '卡通飞行',
    'id': '038',
    'type': 'both', 'desc': '卡通飞行小游戏',
    'more': '卡通飞行小游戏，一款飞行躲避的小游戏',
    'url': 'https://game.chenmo1212.cn/content/038/index.html',
    'cover': 'https://game.chenmo1212.cn/content/038/cover.png'
  }, {
    'name': '六边形下降',
    'id': '039',
    'type': 'both', 'desc': '六边形下降小游戏',
    'more': '六边形下降，一款休闲益智的小游戏',
    'url': 'https://game.chenmo1212.cn/content/039/index.html',
    'cover': 'https://game.chenmo1212.cn/content/039/cover.png'
  }, {
    'name': '银河舰队雷霆战机',
    'id': '040',
    'type': 'pc', 'desc': '银河舰队雷霆战机',
    'more': '银河舰队雷霆战机，一款飞行躲避的小游戏',
    'url': 'https://www.17sucai.com/preview/1750631/2019-09-02/lt/index.html',
    'cover': 'https://game.chenmo1212.cn/content/040/cover.png'
  }, {
    'name': '霓虹球3D滚动游戏',
    'id': '041',
    'type': 'both', 'desc': '霓虹球3D滚动游戏',
    'more': '霓虹球3D滚动游戏，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/041/index.html',
    'cover': 'https://game.chenmo1212.cn/content/041/cover.png'
  }, {
    'name': '打怪小游戏',
    'id': '042',
    'type': 'pc', 'desc': '打怪小游戏',
    'more': '打怪小游戏，一款冒险闯关的小游戏',
    'url': 'https://game.chenmo1212.cn/content/042/index.html',
    'cover': 'https://game.chenmo1212.cn/content/042/cover.png'
  }, {
    'name': '疯狂大脚车小游戏带吃金币闯关',
    'id': '043',
    'type': 'pc', 'desc': '疯狂大脚车小游戏带吃金币闯关',
    'more': '疯狂大脚车小游戏带吃金币闯关，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/043/index.html',
    'cover': 'https://game.chenmo1212.cn/content/043/cover.png'
  }, {
    'name': '黄金矿机千斤顶',
    'id': '045',
    'type': 'both', 'desc': '黄金矿机千斤顶',
    'more': '黄金矿机千斤顶，仿制黄金矿工的小游戏',
    'url': 'https://game.chenmo1212.cn/content/045/index.html',
    'cover': 'https://game.chenmo1212.cn/content/045/cover.png'
  }, {
    'name': '赛车游戏带闯关',
    'id': '046',
    'type': 'pc', 'desc': '赛车游戏带闯关',
    'more': '打怪小游戏，一款冒险闯关的小游戏',
    'url': 'https://game.chenmo1212.cn/content/046/index.html',
    'cover': 'https://game.chenmo1212.cn/content/046/cover.png'
  }, {
    'name': '方块英雄',
    'id': '047',
    'type': 'both', 'desc': '方块英雄',
    'more': '方块英雄，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/047/index.html',
    'cover': 'https://game.chenmo1212.cn/content/047/cover.png'
  }, {
    'name': '3D俄罗斯方块',
    'id': '048',
    'type': 'pc', 'desc': '3D俄罗斯方块',
    'more': '3D俄罗斯方块',
    'url': 'https://game.chenmo1212.cn/content/048/index.html',
    'cover': 'https://game.chenmo1212.cn/content/048/cover.png'
  }, {
    'name': '网络战士小游戏',
    'id': '049',
    'type': 'pc', 'desc': '网络战士小游戏',
    'more': '打怪小游戏，一款冒险闯关的小游戏',
    'url': 'https://www.17sucai.com/preview/776298/2019-08-13/zs/index.html',
    'cover': 'https://game.chenmo1212.cn/content/049/cover.png'
  }, {
    'name': '土豆历险记',
    'id': '050',
    'type': 'both', 'desc': '土豆历险记',
    'more': '土豆历险记，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/050/index.html',
    'cover': 'https://game.chenmo1212.cn/content/050/cover.png'
  }, {
    'name': '飞行员闯关',
    'id': '051',
    'type': 'pc', 'desc': '飞行员闯关',
    'more': '飞行员闯关，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/051/index.html',
    'cover': 'https://game.chenmo1212.cn/content/051/cover.png'
  }, {
    'name': '表情连连看',
    'id': '052',
    'type': 'both', 'desc': '表情连连看',
    'more': '表情连连看，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/052/index.html',
    'cover': 'https://game.chenmo1212.cn/content/052/cover.png'
  }, {
    'name': '飞机对战小游戏',
    'id': '053',
    'type': 'pc', 'desc': '飞机对战小游戏',
    'more': '飞机对战小游戏，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/053/index.html',
    'cover': 'https://game.chenmo1212.cn/content/053/cover.png'
  }, {
    'name': '踏色块',
    'id': '054',
    'type': 'both', 'desc': '踏色块',
    'more': '踏色块，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/054/index.html',
    'cover': 'https://game.chenmo1212.cn/content/054/cover.png'
  }, {
    'name': '一笔画',
    'id': '055',
    'type': 'both', 'desc': '一笔画',
    'more': '一笔画，一款休闲娱乐的小游戏',
    'url': 'https://game.chenmo1212.cn/content/055/index.html',
    'cover': 'https://game.chenmo1212.cn/content/055/cover.png'
  }, {
    'name': '见缝插针',
    'id': '056',
    'type': 'both', 'desc': '见缝插针',
    'more': '踏色块，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/056/play.html',
    'cover': 'https://game.chenmo1212.cn/content/056/cover.png'
  }, {
    'name': '沙滩足球',
    'id': '057',
    'type': 'pc', 'desc': '沙滩足球',
    'more': '沙滩足球，一款休闲娱乐的小游戏',
    'url': 'https://game.chenmo1212.cn/content/057/index.html',
    'cover': 'https://game.chenmo1212.cn/content/057/cover.png'
  }, {
    'name': '切水果大师',
    'id': '058',
    'type': 'both', 'desc': '切水果大师',
    'more': '切水果大师，一款休闲娱乐的小游戏',
    'url': 'https://game.chenmo1212.cn/content/058/index.html',
    'cover': 'https://game.chenmo1212.cn/content/058/cover.png'
  }, {
    'name': '保护我',
    'id': '059',
    'type': 'both', 'desc': '保护我',
    'more': '保护我，一款简单又刺激的小游戏',
    'url': 'https://game.chenmo1212.cn/content/059/index.html',
    'cover': 'https://game.chenmo1212.cn/content/059/cover.png'
  }, {
    'name': '小武士之战',
    'id': '060',
    'type': 'pc', 'desc': '小武士之战',
    'more': '小武士之战，一款休闲娱乐的小游戏',
    'url': 'https://game.chenmo1212.cn/content/060/index.html',
    'cover': 'https://game.chenmo1212.cn/content/060/cover.png'
  }, {
    'name': '飞行棋',
    'id': '061',
    'type': 'both', 'desc': '飞行棋',
    'more': '飞行棋，一款休闲娱乐的小游戏',
    'url': 'https://game.chenmo1212.cn/content/061/index.html',
    'cover': 'https://game.chenmo1212.cn/content/061/cover.png'
  }, {
    'name': '五子棋',
    'id': '062',
    'type': 'both', 'desc': '五子棋',
    'more': '五子棋，三种模式，单人双人以及观战',
    'url': 'https://game.chenmo1212.cn/content/062/index.html',
    'cover': 'https://game.chenmo1212.cn/content/062/cover.png'
  }, {
    'name': '海盗大作战塔防',
    'id': '063',
    'type': 'both', 'desc': '海盗大作战塔防',
    'more': '海盗大作战塔防，一款休闲娱乐的小游戏',
    'url': 'https://game.chenmo1212.cn/content/063/index.html',
    'cover': 'https://game.chenmo1212.cn/content/063/cover.png'
  }, {
    'name': '见缝插针经典版',
    'id': '064',
    'type': 'both', 'desc': '见缝插针经典版',
    'more': '见缝插针经典版',
    'url': 'https://game.chenmo1212.cn/content/064/index.html',
    'cover': 'https://game.chenmo1212.cn/content/064/cover.png'
  }, {
    'name': '圈圈叉叉小游戏',
    'id': '065',
    'type': 'both', 'desc': '圈圈叉叉小游戏',
    'more': '圈圈叉叉小游戏，一款休闲娱乐的小游戏',
    'url': 'https://game.chenmo1212.cn/content/065/index.html',
    'cover': 'https://game.chenmo1212.cn/content/065/cover.png'
  }, {
    'name': '打地鼠小游戏',
    'id': '066',
    'type': 'both', 'desc': '打地鼠小游戏',
    'more': '打地鼠小游戏',
    'url': 'https://game.chenmo1212.cn/content/066/index.html',
    'cover': 'https://game.chenmo1212.cn/content/066/cover.png'
  }, {
    'name': '盲打高手',
    'id': '067',
    'type': 'pc', 'desc': '盲打高手',
    'more': '盲打高手，一款锻炼打字速度的小游戏',
    'url': 'https://game.chenmo1212.cn/content/067/index.html',
    'cover': 'https://game.chenmo1212.cn/content/067/cover.png'
  }
];


const otherData =  [{
  'name': '3D天体效果',
  'id': '001',
  'type': 'both', 'desc': '超级炫酷的3D天体效果',
  'more': '超级炫酷的3D天体效果',
  'url': 'https://game.chenmo1212.cn/other/001/index.html',
  'cover': 'https://game.chenmo1212.cn/other/001/cover.png'
}, {
  'name': '打击器',
  'id': '002',
  'type': 'both', 'desc': '可以自定义的打击器',
  'more': '可以自定义的打击器',
  'url': 'https://game.chenmo1212.cn/other/002/index.html',
  'cover': 'https://game.chenmo1212.cn/other/002/cover.png'
}, {
  'name': '架子鼓',
  'id': '003',
  'type': 'both', 'desc': '可以自定义的架子鼓',
  'more': '可以自定义的架子鼓，可以使用快捷键',
  'url': 'https://game.chenmo1212.cn/other/003/index.html',
  'cover': 'https://game.chenmo1212.cn/other/003/cover.png'
}, {
  'name': '3D跳动Loading加载动画',
  'id': '004',
  'type': 'both', 'desc': '3D跳动Loading加载动画',
  'more': '这是一款基于HTML5 Canvas的3D跳动Loading加载动画，它的另一个特点是可以动态调节动画参数。',
  'url': 'https://game.chenmo1212.cn/other/004/index.html',
  'cover': 'https://game.chenmo1212.cn/other/004/cover.png'
}, ];

export default {
  gameData,
  otherData,
}
